export function scrollToFirstError() {
    document.querySelector(".field-invalid")?.scrollIntoView({ behavior: "smooth" });
}
